import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/oferta/oferta-client.tsx");
